import { useEventListener } from './useEventListener';

export function useOnClickOutside(ref, handler, eventType, eventListenerOptions) {
  useEventListener(
    eventType ?? 'mousedown',
    (event) => {
      const { target } = event;

      if (!target || !target.isConnected) {
        return;
      }

      const isOutside = Array.isArray(ref)
        ? ref
          .filter((r) => Boolean(r.current))
          .every((r) => r.current && !r.current.contains(target))
        : ref.current && !ref.current.contains(target);

      if (isOutside) {
        handler(event);
      }
    },
    undefined,
    eventListenerOptions,
  );
}
